import { render, staticRenderFns } from "./day-empty.vue?vue&type=template&id=961e1b6e&scoped=true&"
import script from "./day-empty.vue?vue&type=script&lang=js&"
export * from "./day-empty.vue?vue&type=script&lang=js&"
import style0 from "./day-empty.vue?vue&type=style&index=0&id=961e1b6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961e1b6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('961e1b6e')) {
      api.createRecord('961e1b6e', component.options)
    } else {
      api.reload('961e1b6e', component.options)
    }
    module.hot.accept("./day-empty.vue?vue&type=template&id=961e1b6e&scoped=true&", function () {
      api.rerender('961e1b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Availability/submodule/Calendar/view/vue/components/days/day-empty.vue"
export default component.exports